import { makeStyles } from "@material-ui/core/styles";
import { alpha } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  notificationBarList:{},
  notificationBarOverlay: {
    position: "fixed",
    width: "100%",
    height: "100%",
    right: 0,
    top: 0,
    bottom: 0,
    left: 0,
    overflow: "auto",
    backgroundColor: "rgba(0, 0, 0, .6)",
    zIndex: 1200,
  },
  notificationDrawer: {
    position: "fixed",
    maxWidth: 450,
    width: "100%",
    right: 0,
    top: 0,
    bottom: 0,
    overflow: "auto",
    backgroundColor: "rgb(241, 242, 246)",
    padding: "60px 0",
    transition: "right 400ms ease-in-out",
    zIndex: 1200,
    [theme.breakpoints.up("md")]: {
      padding: "70px 0",
    },
    [theme.breakpoints.up("lg")]: {
      padding: "80px 0",
    },
  },
  notificationBarTitle: {
    padding: theme.spacing(4, 4, 2),
    fontWeight: 900,
    color: "rgb(36, 42, 56)",
    fontSize: 20,
  },
  notificationBarItem: {
    padding: theme.spacing(1, 4),
  },
  card: {
    padding: theme.spacing(2, 1.5, 6),
    display: "flex",
    backgroundColor: "#fff",
    "&, &:hover": {
      textDecoration: "none",
    },
  },
  cardIcon: {
    width: 40,
    maxWidth: 40,
    flex: "0 0 40px",
  },
  icon: {
    width: 40,
    height: 40,
    borderRadius: 40,
    backgroundColor: alpha(theme.palette.primary.main, 0.5),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 12 * 1.43 + theme.spacing(1),
  },
  iconImg: {
    maxWidth: 20,
    maxHeight: 20,
  },
  cardContent: {
    width: "calc(100% - 40px)",
    maxWidth: "calc(100% - 40px)",
    flex: "0 0 calc(100% - 40px)",
    paddingLeft: theme.spacing(1.5),
  },
  date: {
    fontSize: 12,
    color: "rgba(186, 186, 186, 1)",
    fontWeight: 500,
  },
  title: {
    fontSize: 14,
    fontWeight: 500,
    marginTop: theme.spacing(1),
    color: "rgba(0,0,0,1)",
  },
  desc: {
    fontSize: 14,
    marginTop: theme.spacing(1),
    color: "rgba(0,0,0,.7)",
  },
  loader: {
    padding: theme.spacing(4),
    textAlign: "center",
  },
  noNotificationText: {
    padding: theme.spacing(0, 4, 4, 4),
    fontSize: "16px",
  },
}));
